import React, { Fragment } from 'react';
import { string } from 'prop-types';
import Availability from '../availability';
import ContactInfo from '../contact-info';
import { api } from '../../api/Axios';
import Loading from '../../../estimateBuilder/components/Loading';
import './spinner.css';
import cookiesFactory from '../../../../base/cookies-factory';

class App extends React.Component {
  static errorMessages = {
    missingFirstName: 'please enter your first name.',
    missingLastName: 'please enter your last name.',
    missingAddress: 'please enter your address.',
    missingCity: 'please enter your city.',
    missingState: 'please enter your state.',
    missingZip: 'please enter your zip.',
    missingEmail: 'please enter your e-mail.',
    missingLdap: 'please enter your THD Ldap.',
    missingPhone: 'please enter your phone number.',
    invalidPhone: 'invalid phone number.',
    invalidEmail: 'invalid email address.',
    invalidZipCode: 'please enter a valid 5 digit zip code.',
    invalidThdLdap: 'Invalid THD Ldap. (Alpha numeric characters only).',
  };

  constructor(props) {
    super(props);
    this.state = {
      address1: '',
      address2: '',
      state: '',
      city: '',
      zipCode: '',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      ldap: '',
      firstNameError: '',
      lastNameError: '',
      emailError: '',
      phoneNumberError: '',
      address1Error: '',
      stateError: '',
      cityError: '',
      ldapError: '',
      isShuttersAvailableInZipCode: null,
      hasContactedSFI: null,
      loading: false,
      visible: false,
    };
  }

  show = () => {
    this.setState({ visible: true });
    this.resetState();
    this.sendDigitalData('sfandi>zip code check', 'sfani');
  }

  hide = () => {
    this.setState({ visible: false });
  }

  resetState = () => {
    if (!this.state.wasContactSubmitted) {
      this.setState({
        address1: '',
        address2: '',
        state: '',
        city: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        ldap: '',
        firstNameError: '',
        lastNameError: '',
        emailError: '',
        phoneNumberError: '',
        address1Error: '',
        stateError: '',
        cityError: '',
        ldapError: '',
        isShuttersAvailableInZipCode: null,
        hasContactedSFI: null,
      });
    }
  }

  sendDigitalData = (pageName, pageType) => {
    window.digitalData.page = {
      pageInfo: {
        pageName,
        pageType,
      },
    };
    window.ddoInit(window.digitalData);
  }

  checkAvailability = (event) => {
    event.preventDefault();
    const { zipCode } = this.state;
    if (!this.validateZipCode(zipCode)) return;
    const resource = `/api/shutters/availability/${zipCode}`;
    this.setState({ loading: true }, () => {
      api.get(resource).then((response) => {
        this.setState({ isShuttersAvailableInZipCode: response.data }, () => {
          if (response.data) {
            this.sendDigitalData('sfandi>address check', 'sfani');
          } else {
            this.sendDigitalData('sfandi>not available', 'sfani');
          }
        });
      }).catch((error) => {
      // eslint-disable-next-line no-console
        console.log(error);
      }).then(() => {
        this.setState({ hasContactedSFI: true });
        this.setState({ loading: false });
      });
    });
  }

  submitContactInfo = (event) => {
    event.preventDefault();

    // Validate again
    if (!this.validateContactInfo()) return;

    const resource = '/api/shutters/lead';

    const data = {
      FirstName: this.state.firstName,
      LastName: this.state.lastName,
      EmailAddress: this.state.email,
      Phone: this.state.phoneNumber,
      CecLdap: this.state.ldap,
      Zip: this.state.zipCode,
      Address1: this.state.address1,
      Address2: this.state.address2,
      State: this.state.state,
      City: this.state.city,
    };
    this.setState({ loading: true }, () =>
      api.post(resource, data).then((response) => {
        if (response.data) {
          window.open(`/infopage/shutters-sfi-confirmation/?name=${this.state.firstName}`, '_self');
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.setState({ loading: false });
      }));
  }

  handleChange = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  }

  validateContactInfo = () => {
    const isValid = (this.validatePhoneNumber(this.state.phoneNumber)
              && this.validateEmail(this.state.email)
              && this.validateRequiredFields(this.state.firstName, 'firstName', 'firstNameError', App.errorMessages.missingFirstName)
              && this.validateRequiredFields(this.state.lastName, 'lastName', 'lastNameError', App.errorMessages.missingLastName)
              && this.validateRequiredFields(this.state.address1, 'address1', 'address1Error', App.errorMessages.missingAddress)
              && this.validateRequiredFields(this.state.city, 'city', 'cityError', App.errorMessages.missingCity)
              && this.validateRequiredFields(this.state.state, 'state', 'stateError', App.errorMessages.missingState));

    if (cookiesFactory.isInternalUser()) {
      return isValid && this.validateLdap(this.state.ldap);
    }
    return isValid;
  }

  handleOnBlur = (event) => {
    if (event.target.id === 'phoneNumber') { this.validatePhoneNumber(event.target.value); return; }
    if (event.target.id === 'email') { this.validateEmail(event.target.value); return; }
    if (event.target.id === 'ldap') { this.validateLdap(event.target.value); return; }

    if (event.target.id === 'firstName') { this.validateRequiredFields(event.target.value, 'firstName', 'firstNameError', App.errorMessages.missingFirstName); return; }
    if (event.target.id === 'lastName') { this.validateRequiredFields(event.target.value, 'lastName', 'lastNameError', App.errorMessages.missingLastName); return; }
    if (event.target.id === 'address1') { this.validateRequiredFields(event.target.value, 'address1', 'address1Error', App.errorMessages.missingAddress); return; }
    if (event.target.id === 'city') { this.validateRequiredFields(event.target.value, 'city', 'cityError', App.errorMessages.missingCity); return; }
    if (event.target.id === 'state') { this.validateRequiredFields(event.target.value, 'state', 'stateError', App.errorMessages.missingState); }
  }

  handleOnKeyPress = (event) => {
    const theEvent = event;
    if (theEvent.target.type === 'tel') {
      let key;
      if (theEvent.type === 'paste') {
        key = event.clipboardData.getData('text/plain');
      } else {
        key = event.keyCode || event.which;
        key = String.fromCharCode(key);
      }
      const regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) {
          theEvent.preventDefault();
        }
      }
    }
  }

  validateRequiredFields =(value, key, errorKey, errorMessage) => {
    if (value) {
      this.setState({ [errorKey]: '', [key]: value });
      return true;
    }
    this.setState({ [errorKey]: errorMessage });
    return false;
  }

  validateEmail = (email) => {
    if (email === '') {
      this.setState({ emailError: App.errorMessages.missingEmail });
      return false;
    }

    const emailErrorMessage = this.isEmailValid(email);
    if (emailErrorMessage) {
      this.setState({ emailError: emailErrorMessage });
      return false;
    }
    this.setState({ emailError: '', email });
    return true;
  }

  validateLdap = (ldap) => {
    if (!ldap) {
      this.setState({ ldapError: App.errorMessages.missingLdap });
      return false;
    }

    const ldapLength = ldap.length;
    if (ldapLength < 3 || ldapLength > 9) {
      this.setState({ ldapError: 'THD Ldap must be 3-8 characters only.' });
      return false;
    }

    const ldapError = this.isTHDUserIdValid(ldap);
    if (ldapError) {
      this.setState({ ldapError });
      return false;
    }
    this.setState({ ldapError: '', ldap });
    return true;
  }

  validatePhoneNumber = (phoneNumber) => {
    if (phoneNumber === '') {
      this.setState({ phoneNumberError: App.errorMessages.missingPhone });
      return false;
    }
    const errorMessage = this.isPhoneValid(phoneNumber);
    if (errorMessage) {
      this.setState({ phoneNumberError: errorMessage });
      return false;
    }
    this.setState({ phoneNumberError: '', phoneNumber });
    return true;
  }

  handleZipCodeChange = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ zipCode: e.target.value });
      this.setState({ zipCodeError: '' });
    }
  }

  validateZipCode = (zipCode) => {
    if (zipCode === '') {
      this.setState({ zipCodeError: App.errorMessages.missingZip });
      return false;
    }
    const errorMessage = this.isZipCodeValid(zipCode);
    if (errorMessage) {
      this.setState({ zipCodeError: errorMessage });
      return false;
    }
    this.setState({ zipCodeError: '' });
    this.setState({ zipCode });
    return true;
  }

  isPhoneValid = (phone) => {
    const usOrCanadianPhoneRegex = /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/;
    if (!usOrCanadianPhoneRegex.test(phone)) {
      return App.errorMessages.invalidPhone;
    }
    return '';
  }

  isEmailValid = (email) => {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!emailRegex.test(email)) {
      return App.errorMessages.invalidEmail;
    }
    return '';
  }

  isZipCodeValid = (zipCode) => {
    if (/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)) {
      return '';
    }
    return App.errorMessages.invalidZipCode;
  }

  isTHDUserIdValid = (thdUserId) => {
    const thdUserIdRegex = new RegExp('^[A-Za-z0-9]{3,8}$');
    if (!thdUserIdRegex.test(thdUserId)) {
      return App.errorMessages.invalidThdLdap;
    }
    return '';
  }

  render() {
    if (!this.state.visible) return null;

    let content = (
      <Fragment>
        <div className="pa3 pa4-ns">
          <h1 className="f3 f2-ns near-black">Coming Soon!</h1>
          <p>
            Our in-home plantation shutter service is not available in your
            area at this time. Interested in other solutions?
            Give us a call at
            <span style={{ whiteSpace: 'nowrap' }}>
              <strong> {this.props.sfiPhoneNumber } </strong>
            </span>
            to learn more about our Online Exclusive shutters.
          </p>
          <button className="gcc-btn gcc-btn-secondary w-100" onClick={() => this.resetState()} >Try Again</button>
        </div>
      </Fragment>
    );

    if (!this.state.hasContactedSFI) {
      content = (<Availability
        checkAvailability={this.checkAvailability}
        zipCode={this.state.zipCode}
        zipCodeError={this.state.zipCodeError}
        handleChange={e => this.handleZipCodeChange(e)}
        sfiPhoneNumber={this.props.sfiPhoneNumber}
      />);
    }
    if (this.state.isShuttersAvailableInZipCode) {
      content = (<ContactInfo
        submitContactInfo={e => this.submitContactInfo(e)}
        handleChange={e => this.handleChange(e)}
        handleOnBlur={e => this.handleOnBlur(e)}
        handleOnKeyPress={e => this.handleOnKeyPress(e)}
        address1={this.state.address1}
        address2={this.state.address2}
        state={this.state.state}
        city={this.state.city}
        zipCode={this.state.zipCode}
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        email={this.state.email}
        phoneNumber={this.state.phoneNumber}
        ldap={this.state.ldap}
        phoneNumberError={this.state.phoneNumberError}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        emailError={this.state.emailError}
        address1Error={this.state.address1Error}
        cityError={this.state.cityError}
        stateError={this.state.stateError}
        ldapError={this.state.ldapError}
        showLdap={cookiesFactory.isInternalUser()}
        sfiPhoneNumber={this.props.sfiPhoneNumber}
      />);
    }

    return (
      <div className="w-100">
        { content }
        <Loading isLoading={this.state.loading} />
      </div>
    );
  }
}

App.propTypes = {
  sfiPhoneNumber: string.isRequired,
};

export default App;
